<template>
  <div class="edume-knowledge-hub-section">
    <Content
      v-for="(content, index) of visibleContents"
      :key="`${content.contentType}-${content.id}`"
      :title="content.title"
      :image-url="content.imageUrl"
      :status="content.status"
      :incomplete-activities="content.incompleteActivities"
      :tenant-url="tenantUrl"
      :parent-group-id="parentGroupId"
      :team-ids="content.teamIds"
      :content-type="content.contentType"
      :content-id="
        content.moduleId || content.guideId || content.scormContentId
      "
      :additional-style="additionalStyle(index)"
      :is-desktop="isDesktop"
      :due-date="content.dueDate"
    />
    <ShowMoreDropdown
      v-if="hasDropdownContents"
      :contents="dropdownContents"
      :tenant-url="tenantUrl"
      :parent-group-id="parentGroupId"
      :is-desktop="isDesktop"
    />
  </div>
</template>

<script>
import Content from './Content.vue';
import ShowMoreDropdown from './ShowMoreDropdown.vue';

export default {
  components: {
    Content,
    ShowMoreDropdown,
  },
  props: {
    contents: {
      type: Array,
      required: true,
    },
    tenantUrl: {
      type: String,
      required: true,
    },
    parentGroupId: {
      type: Number,
      required: true,
    },
    isDesktop: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    visibleContents() {
      return this.contents.length > 3
        ? this.contents.slice(0, 2)
        : this.contents;
    },
    dropdownContents() {
      return this.contents.length > 3 ? this.contents.slice(2) : [];
    },
    hasDropdownContents() {
      return this.contents && this.dropdownContents.length > 0;
    },
  },
  methods: {
    additionalStyle(index) {
      let style = '';
      if (
        index === 0 &&
        (this.visibleContents.length > 1 || this.hasDropdownContents)
      ) {
        style = 'first';
      } else if (this.visibleContents.length > 1) {
        if (
          index === this.visibleContents.length - 1 &&
          !this.hasDropdownContents
        ) {
          style = 'last';
        } else {
          style = 'middle';
        }
      }
      return style;
    },
  },
};
</script>
<style>
.edume-knowledge-hub-section {
  margin-bottom: 12px;
}
</style>
